module.exports = __webpack_public_path__ + "img/audit_bg.8a9bc89c.jpg";